export default __webpack_public_path__ + "static/media/vitalik_poap_20.c55c731c.svg";